// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2K-MX","unreadBadge":"styles_unreadBadge__OLwD2","modalContent":"styles_modalContent__22KqH","modal":"styles_modal__2XTnY"};